import { useUserData } from "../utils/UserData"; 
import profilePic from "../assets/profilepic.jpg";
import { Link } from "react-router-dom";
import { usePageTitle } from "../utils/usePageTitle";

export default function AboutPage() {
    usePageTitle("About");
    const data = useUserData();

    return (
        <main className="max-w-3xl mx-auto px-6 py-12 text-gray-800">
        <figure className="flex justify-center mb-6">
            <img
            src={profilePic}
            alt="Profile"
            className="rounded-full w-48 h-48 object-cover border-4 border-slate-300 shadow-md"
            />
        </figure>

        <h2 className="text-3xl font-semibold text-center text-slate-800 mb-4">
            About
        </h2>

        <article className="space-y-4 text-base leading-relaxed">
        <p>Hi! I'm <span className="font-medium">{data.name}</span></p>
            {data.longDescription.split("\n").map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
            ))}
        </article>

        <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-4 text-center">
            <Link
            to="/projects"
            className="bg-purple-700 text-white px-6 py-2 rounded-md hover:bg-purple-800 transition"
            >
            View Projects
            </Link>

            <Link
            to={`mailto:${data.socialMedia.email}`}
            className="border border-purple-700 text-purple-700 px-6 py-2 rounded-md hover:bg-purple-50 transition"
            >
            Contact Me
            </Link>
        </div>
        </main>
    );
}
